import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import ClusterHealthIncidentsRequest = Cloud.RavenDB.Core.Dto.ClusterHealth.ClusterHealthIncidentsRequest;
import ClusterHealthIncidentsResponse = Cloud.RavenDB.Core.Dto.ClusterHealth.ClusterHealthIncidentsResponse;
import ClusterHealthSuggestionsResponse = Cloud.RavenDB.Core.Dto.ClusterHealth.ClusterHealthSuggestionsResponse;
import ClusterHealthSuggestionsRequest = Cloud.RavenDB.Core.Dto.ClusterHealth.ClusterHealthSuggestionsRequest;

export default class ClusterHealthService extends AbstractService {
    getClusterHealthIncidents = async (
        request: ClusterHealthIncidentsRequest
    ): Promise<ClusterHealthIncidentsResponse> => {
        const response = await this.post<ClusterHealthIncidentsRequest, ClusterHealthIncidentsResponse>(
            ApiRoutes.clusterHealth.getClusterHealthIncidents(),
            request
        );

        return response.data;
    };

    getClusterHealthSuggestions = async (
        request: ClusterHealthSuggestionsRequest
    ): Promise<ClusterHealthSuggestionsResponse> => {
        const response = await this.post<ClusterHealthSuggestionsRequest, ClusterHealthSuggestionsResponse>(
            ApiRoutes.clusterHealth.getClusterHealthSuggestions(),
            request
        );

        return response.data;
    };
}
